export type BlogPost = {
  id: string;
  title: string;
  publishedAt: string;
  wordCount: number;
  readingTimeMinutes: number;
  thumbnailUrl1024x512: string;
  url: string;
};
